// extracted by mini-css-extract-plugin
module.exports = {"up":"Chevron_up__A8IPR","left":"Chevron_left__znLTD","right":"Chevron_right__rlN7s","down":"Chevron_down__CjxMi"};